
import ResumeItem from './ResumeItem';
import { CompanyMovementsTotalizerData } from '@/features/privateCompanies/types/companyMovementsTotalizer.type';
import { companyResumeItems } from '@/features/privateCompanies/constants/companyMovementsTotalizer.constants';
interface ResumeListProps {
  data: CompanyMovementsTotalizerData;
}

const ResumeList = ({ data }: ResumeListProps) => {
  return (
    <div className="flex gap-6">
      {companyResumeItems(data).map((itemConfig, index) => <ResumeItem key={index} {...itemConfig}/>)}
    </div>
  )
}

export default ResumeList